import axiosInstance from '../../config/axios.config';
// сокеты передаются в Экшены в сторе
// типы экшенов
import {
  ADD_BRIGADE_COMPOSITION,
  ADD_ERRORS,
  REMOVE_BRIGADE_INFO,
  INIT_BRIGADE_COMPOSITION,
  INIT_BRIGADE_INFO,
  INIT_BRIGADES,
  INIT_CURRENT_LOCATION_WORK,
  INIT_LOCATION_WORK,
  INIT_SIGNALS,
  INIT_TRANSFER_OBJECT,
  REMOVE_BRIGADE_COMPOSITION,
  REMOVE_BRIGADE_SIGNALS,
  REMOVE_ERRORS,
  INIT_ALL_SIGNALS,
  RESET_MESH,
  REMOVE_CURRENT_LOCATION_WORK,
  REMOVE_ALL_SIGNALS,
  ADD_BRIGADES_COORDS,
  UPDATE_BRIGADE,
  CLEAR_BRIGADES,
  UPDATE_SINGLE_BRIGADE,
} from '../type';
// экшены
import { addError } from './error.action';
import { initMapMarkers } from './mapMarkers.action';
// утилиты
import { createSocketListener } from '../../utils/socketUtils/createSocketListener';
import { createSocketEmitter } from '../../utils/socketUtils/createSocketEmitter';
import { getValidMarkers } from '../../utils/markerValidation';
import { success } from './loader.action';
import { downloadFile } from '../../utils/downloadFile';
import { handleRequestError } from '../../utils/handleRequestError';
import { logSocketError } from '../../utils/socketUtils/logSocketError';

/**SOCKET */
/** Экшены - генерация событий */

// отправляем событие чтобы сервер начал слать координаты
export const emitGetCoordsStart = createSocketEmitter('coords_listen_start');

// отправляем событие чтобы сервер перестал слать координаты
export const emitGetCoordsStop = createSocketEmitter('coords_listen_stop');

// отправляем событие чтобы сервер начал слать инфо по бригадам
export const emitBrigadeListenStart = createSocketEmitter('brigade_listen_start');

// отправляем событие чтобы сервер закончил слать инфо по бригадам
export const emitBrigadeListenStop = createSocketEmitter('brigade_listen_stop');

// отправляем событие чтобы сервер начал слать инфо по сигналам
export const emitPlaceWorkListenStart = createSocketEmitter('info_listen_start');

// отправляем событие чтобы сервер закончил слать инфо по сигналам
export const emitPlaceWorkListenStop = createSocketEmitter('info_listen_stop');

// отправляем событие чтобы получить сигналы (таблица из вкладки сигналы)
export const emitBrigadeAllSignals = createSocketEmitter('signals_listen_start');

// отправляем событие чтобы сервер закончил слать сигналы
export const emitBrigadeAllSignalsListenStop = createSocketEmitter('signals_listen_stop');

// отправляем событие чтобы получить состав бригады
export const emitBrigadeComposition = createSocketEmitter('brigade_get');

// отправляем событие подтверждения добавления устройства
export const emitBrigadeCompositionAddDevice = createSocketEmitter('brigade_add');

// отправляем событие подтверждения исключения устройства
export const emitBrigadeCompositionRemoveDevice = createSocketEmitter('brigade_remove');

// отправляем событие чтобы получить место работ
export const emitLocationWork = createSocketEmitter('location_choose_get');

// отправляем событие для изменения места работ
export const emitEditPlaceWork = createSocketEmitter('location_choose_set');

// отправляем событие для начала работ
export const emitStartWork = createSocketEmitter('start_session');

// отправляем событие подтверждения "Завершить работу"
export const emitFinishWork = createSocketEmitter('brigade_finish_session');

// отправляем событие выхода на путь
export const emitWayOut = createSocketEmitter('exit_rails');

// включение режима 'тихо' или 'громко' в зависимости от data
export const emitSignalModeChange = createSocketEmitter('set_signal_mode');

// включение режима 'зона' или 'движение' в зависимости от data
export const emitWorkModeChange = createSocketEmitter('set_work_mode');

// ввод ординаты
export const emitSetCanEnterOrd = createSocketEmitter('set_can_enter_ord');

// работа без КУОБЗ
export const emitSetStandalone = createSocketEmitter('set_standalone');

// включение режима Ограждение
export const emitRestrictOn = createSocketEmitter('btn_restrict_start');

// выключение режима Ограждение
export const emitRestrictOff = createSocketEmitter('btn_restrict_finish');

// включение режима Перенос
export const emitTransferStart = createSocketEmitter('btn_transfer_start');

// выключение режима Перенос
export const emitTransferFencingOff = createSocketEmitter('btn_transfer_finish');

// получение РЦ для переноса
export const emitGetTransferObjects = createSocketEmitter('transfer_objects_get');

// отправка РЦ для переноса
export const emitTransferOn = createSocketEmitter('transfer_objects_select');

// отправляем событие для сброса Mesh
export const emitResetMesh = createSocketEmitter('reset_mesh');

/** Экшены - прослушивание событий и обновления стейтов */

// слушаем событие обновления стейта бригад
export const listenUpdateBrigade = createSocketListener('update_brigade', UPDATE_BRIGADE);

// слушаем событие
export const listenBrigadeInfo = createSocketListener('brigade_info', INIT_BRIGADE_INFO);

// обновление стейта
export const addCoords = (coords) => ({
  type: ADD_BRIGADES_COORDS,
  payload: coords,
});

/**
 * Слушает событие 'brigades_coords' и диспатчит данные в зависимости от источника: 'map' (иначе считается 'table').
 *
 * @param {string} [source='table'] - Источник вызова ('map' или 'table').
 * @returns {Function} thunk-функция для подписки на событие и последующей отписки.
 */
export const listenBrigadesCoords = (source = 'table') => {
  return (dispatch, getState, { socket }) => {
    socket?.on('brigades_coords', ({ result, data, reason, ...rest }) => {
      if (result !== 'ok') {
        logSocketError({
          eventName: 'brigades_coords',
          payload: { result, data, reason, ...rest },
          source,
          location: 'src/redux/actions/brigades.action.js',
        });
        return;
      }

      if (!Array.isArray(data)) return;

      if (source === 'map') {
        // Используем централизованную фильтрацию валидных маркеров
        const validMarkers = getValidMarkers(data);
        dispatch(initMapMarkers(validMarkers));
      } else {
        dispatch(addCoords(data));
      }
    });

    return () => {
      socket.off('brigades_coords');
    };
  };
};

// слушаем событие
export const listenPlaceWorkInfo = createSocketListener('info', INIT_SIGNALS);

// слушаем событие для получения сигналов
export const listenBrigadeAllSignalsInfo = createSocketListener('signals', INIT_ALL_SIGNALS);

// слушаем событие
export const listenLocationWorkInfo = createSocketListener('location_choose_get_reply', INIT_LOCATION_WORK);

// слушаем событие  получаем информацию по выбранному месту работы
export const listenCurrentLocationWorkInfo = createSocketListener('work_place_info', INIT_CURRENT_LOCATION_WORK);

// слушаем событие, получаем состав бригады
export const listenBrigadeCompositionInfo = createSocketListener('brigade_get_reply', INIT_BRIGADE_COMPOSITION);

// обновление стейта — извлекаем id явно из объекта
export const removeDeviceFromBrigadeComposition = ({ deviceId }) => ({
  type: REMOVE_BRIGADE_COMPOSITION,
  payload: deviceId,
});
// слушаем событие, получаем подтверждение удаления устройства из состава бригады
export const listenBrigadeCompositionRemoveDevice = createSocketListener(
  'brigade_remove_reply',
  removeDeviceFromBrigadeComposition,
  () => addError({ error: 'При исключении устройства произошла ошибка' })
);

// обновление стейта
export const addErrors = (options) => ({
  type: ADD_ERRORS,
  payload: options,
});

// слушаем событие, получаем подтверждение добавления устройства в состав бригады
export const listenBrigadeCompositionAddDevice = createSocketListener(
  'brigade_add_reply',
  ADD_BRIGADE_COMPOSITION,
  addErrors
);

// слушаем событие, получаем РЦ для переноса
export const listenGetTransferObjectsReply = createSocketListener(
  'transfer_objects_get_reply',
  INIT_TRANSFER_OBJECT,
  (error) => addErrors({ error: error || 'Не удалось получить объекты для переноса' })
);

// обновление стейта resetMesh при сбросе Mesh
export const resetMesh = (payload) => ({
  type: RESET_MESH,
  payload
});

// слушаем событие, получаем подтверждение сброса Mesh
export const listenResetMesh = createSocketListener(
  'reset_mesh_reply',
  RESET_MESH,
  null,
  true // raw mode — передаём весь payload
);

/**HTTP */
/** Экшены - отправки запросов и обновления стейтов */

// обновление стейта бригад
export const initBrigades = (brigades) => ({
  type: INIT_BRIGADES,
  payload: brigades,
});

// обновление стейта бригады
export const updateSingle = (device) => ({
  type: UPDATE_SINGLE_BRIGADE,
  payload: device,
});
// очищаем стейт ошибок
export const removeErrors = (options) => ({
  type: REMOVE_ERRORS,
  payload: options,
});
// очищаем стейт бригад
export const clearBrigades = () => ({
  type: CLEAR_BRIGADES,
  payload: [],
});

// очищаем стейт с местом работ при закрытии вкладки бригада
export const removeStateCurrentLocationsWork = () => ({
  type: REMOVE_CURRENT_LOCATION_WORK,
  payload: {},
});

// очищаем стейт сигналов после закрытия вкладки сигналы
export const removeStateAllSignals = () => ({
  type: REMOVE_ALL_SIGNALS,
  payload: [],
});

// очищаем стейт brigadeInfo после закрытия вкладки бригады
export const removeStateBrigadeInfo = () => ({
  type: REMOVE_BRIGADE_INFO,
  payload: {},
});

// очищаем стейт brigadeInfo после закрытия вкладки бригады
export const removeStateBrigadeSignals = () => ({
  type: REMOVE_BRIGADE_SIGNALS,
  payload: {},
});

function getFilenameFromContentDisposition(header) {
  const match = header?.match(/filename\*?=(?:UTF-\d['']*)?"?([^";\n]+)"?/i);
  return match?.[1] || null;
}

//загрузка логов ИУР
export const downloadIurLogsAction = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`/api/brigades/logs/${id}`, {
      responseType: 'blob',
      headers: {
        'Skip-Interceptor': 'true',
      },
    });

    // Попробуем достать имя файла из заголовка
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'iur-logs';

    if (contentDisposition) {
      const extractedFilename = getFilenameFromContentDisposition(contentDisposition);
      if (extractedFilename) {
        filename = extractedFilename;
      }
    }

    if (response?.data) {
      dispatch(success());
      downloadFile(response.data, filename);
    }
  } catch (error) {
    handleRequestError(error, dispatch);
    console.error('Download error:', error);
  }
};

// запрос на получение всех бригад
export const initBrigadesFromServer = (query) => async (dispatch, getState) => {
  try {
    const result = await axiosInstance(`/api/brigades${query}`);

    if (result.data && result.status === 200) {
      await dispatch(initBrigades(result.data));
      return result; // Возвращаем данные для использования в .then()
    }
  } catch (error) {
    console.log(error);
  }
};

// запрос на обновление массива одной бригады в массиве всех бригад
export const initBrigadeAfterUpdate = (updatedBrigadeId) => async (dispatch) => {
  try {
    if (updatedBrigadeId) {
      const result = await axiosInstance(`/api/brigades?id=${updatedBrigadeId}`);
      if (result.data && result.status === 200) {
        dispatch(updateSingle(result.data[0]));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const getDeviceById = (deviceId) => async (dispatch) => {
  try {
    const { data } = await axiosInstance(`/api/brigades?deviceId=${encodeURIComponent(deviceId)}`);
    dispatch(clearBrigades());
    dispatch(initBrigades(data));
  } catch (error) {
    console.log(error);
  }
};
